import {Flex, Text} from '@priority-software/priority-style-react';
import React, {useRef, useState, useEffect} from 'react';
import {SortIcon} from '../../../../components/Common/SortIcon';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';
import {ModernTooltip} from '../../../../components/Common/Tooltip/ModernTooltip';

interface Props {
    onSort: () => void;
    title: string;
    isSortActive: boolean;
    isDesc?: boolean;
    testId: string;
}
const HeaderCol = ({title, isSortActive, onSort, isDesc, testId}: Props) => {
    const dataTestId = testId && createDataTestId(`report-list-col-header-${testId}`);
    const [isTextTruncated, setIsTextTruncated] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);

    // Check if text is truncated to show tooltip only when needed
    useEffect(() => {
        const checkTruncation = () => {
            if (textRef.current) {
                const isTruncated = textRef.current.scrollWidth > textRef.current.clientWidth;
                setIsTextTruncated(isTruncated);
            }
        };

        checkTruncation();
        // Add resize listener to recheck when window size changes
        window.addEventListener('resize', checkTruncation);
        return () => window.removeEventListener('resize', checkTruncation);
    }, [title]);

    const content = (
        <Flex justifyContent="flex-start" alignItems="center">
            <Text 
                skin="caption-2" 
                textColor="primary-700"
                componentClasses={styles.headerText}
            >
                <div ref={textRef} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {title}
                </div>
            </Text>
            <SortIcon isDesc={isDesc} isActive={isSortActive} />
        </Flex>
    );
    
    return (
        <div onClick={onSort} className={styles.tableHeaderItem} {...dataTestId}>
            {isTextTruncated ? (
                <ModernTooltip tooltip={title} position="top">
                    {content}
                </ModernTooltip>
            ) : (
                content
            )}
        </div>
    );
};

export default HeaderCol;
